import React from 'react';

const ContasPagarContext = React.createContext();

export default ContasPagarContext;
